import { FieldArray, useFieldArray } from "react-final-form-arrays";
import { isNil } from "lodash";
import classNames from "classnames";

import { ProductCardField } from "../../Shared/Fields/ProductCardField";
import { useSyncUrlParam } from "./useSyncUrlParam";
import { useProductsQuery } from "../../hooks/queries/useProductsQuery";

export function ProductSelector({
    values,
    form,
    name = "products",
    maxQuantity,
    title,
    hidden = false,
    queryOptions = {},
    getProductCardProps = () => {},
    filterProduct = () => true,
}) {
    const { data: products, isLoading: isProductsLoading } = useProductsQuery({
        queryKey: [name],
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        ...queryOptions,
    });
    const productsFieldArray = useFieldArray(name);
    useSyncUrlParam(
        "part_number",
        (value) => {
            const mainProduct = products.find((product) =>
                product.materials.find((material) => material.number === value)
            );
            const partProduct = mainProduct?.materials.find(
                (material) => material.number === value
            );
            const partProductIndex = productsFieldArray.fields.value.findIndex(
                (product) => product.id === partProduct?.id
            );
            const stockQuantity = partProduct?.stockQuantity || partProduct?.stock_quantity;

            if (partProductIndex !== -1 && (isNil(stockQuantity) || stockQuantity > 0)) {
                productsFieldArray.fields.update(partProductIndex, {
                    ...partProduct,
                    amount: 1,
                });
            }
        },
        {
            enabled: !isProductsLoading && !!products,
        }
    );

    if (isProductsLoading || !products || products?.length === 0 || hidden)
        return null;

    return (
        <div>
            {title && <h3 className={"mt-9"}>{title}</h3>}

            <FieldArray name={name}>
                {({ fields }) => (
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        {fields.map((name, index) => {
                            const product = fields.value[index];
                            const stockQuantity = product.stockQuantity || product.stock_quantity;
                            const maxAmount = !isNil(stockQuantity) && !isNil(maxQuantity) ? Math.min(stockQuantity, maxQuantity) : product.stockQuantity || product.stock_quantity || maxQuantity

                            return (
                                <ProductCardField
                                    name={`${name}.amount`}
                                    key={name}
                                    title={product.description}
                                    priceGross={product.price?.priceGross}
                                    currency={product.price?.currency}
                                    vat={product.price?.vat}
                                    text={product.text}
                                    maxAmount={maxAmount}
                                    imgUrl={product.image}
                                    {...getProductCardProps(product)}
                                    className={classNames({
                                        "hidden": !filterProduct(product),
                                    })}
                                />
                            );
                        })}
                    </div>
                )}
            </FieldArray>
        </div>
    );
}
